import type { QueryClient } from "@tanstack/react-query";
import type { BoardResponse, CardView } from "@breeze/shared";

// Apply a full CardView to every cached board variant, respecting each
// variant's `archived` filter. Handles archive (remove from default view) and
// unarchive (insert back) without forcing a refetch.
export function applyCardToBoardCache(
  qc: QueryClient,
  card: CardView
): void {
  qc.getQueryCache()
    .findAll({ queryKey: ["board"] })
    .forEach((query) => {
      const prev = query.state.data as BoardResponse | undefined;
      if (!prev) return;

      const meta = query.queryKey[1] as { archived?: boolean } | undefined;
      const wantArchived = meta?.archived === true;
      const cardArchived = card.archivedAt !== null;
      const shouldInclude = wantArchived || !cardArchived;

      const idx = prev.cards.findIndex((c) => c.cardId === card.cardId);

      if (!shouldInclude) {
        if (idx === -1) return;
        qc.setQueryData(query.queryKey, {
          ...prev,
          cards: prev.cards.filter((c) => c.cardId !== card.cardId),
        });
        return;
      }

      if (idx === -1) {
        qc.setQueryData(query.queryKey, {
          ...prev,
          cards: [...prev.cards, card],
        });
      } else {
        const cards = [...prev.cards];
        cards[idx] = card;
        qc.setQueryData(query.queryKey, { ...prev, cards });
      }
    });
}
